import { render, staticRenderFns } from "./CmsUsers.vue?vue&type=template&id=1b6bbf4a&scoped=true"
import script from "./CmsUsers.vue?vue&type=script&lang=ts"
export * from "./CmsUsers.vue?vue&type=script&lang=ts"
import style0 from "./CmsUsers.vue?vue&type=style&index=0&id=1b6bbf4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6bbf4a",
  null
  
)

export default component.exports